<template>
  <div>
    <footer class="c-main-footer font-default">
      <div class="c-main-footer__inner">
        <div class="c-main-footer__top">
          <div class="container">
            <p>
              <a
                :href="$router.resolve({ name: 'rules' }).href"
                target="_blank"
              >
                {{ $t("SHARED__CONTEST_RULES") }}
              </a>
              |
              <a
                :href="
                  `https://www.tuango.ca/${$i18n.locale}/GroupBuyPrivacyPolicy/?${utmQs}`
                "
                target="_blank"
                >{{ $t("SHARED__PRIVACY_POLICY") }}</a
              >
            </p>

            <p
              v-html="
                $t('SHARED__ADDRESS').replace(
                  'https://www.tuango.ca',
                  `https://www.tuango.ca/${$i18n.locale}/?${utmQs}`
                )
              "
            ></p>
            <p>&copy; {{ year }}, {{ $t("SHARED__COPYRIGHT") }}</p>
          </div>
        </div>
        <!--        <main-image-section
          img="https://contest2018.s3.amazonaws.com/email/idc-solis-banner.jpg"
          :logo="
            `https://contest2018.s3.amazonaws.com/idc_banner_logo_${$i18n.locale}.png`
          "
          class="banner"
          style="position: relative; z-index: 1"
        />-->
        <div class="c-main-footer__bottom">
          <div class="container" v-html="$t('SHARED__COPYRIGHT_FULL')"></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

const { mapGetters } = createNamespacedHelpers("app")

export default {
  name: "MainFooter",
  computed: {
    ...mapGetters(["utmQs"]),
    year() {
      const d = new Date()
      return d.getFullYear()
    }
  }
}
</script>
